/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import HorizontalTabs from 'sushiweb/HorizontalTabs';
import styled from 'styled-components';
import {
  TASK_STATUSES,
  types,
} from '../../components/widgets/ActionsView/constants';
import { ChevronLeft, ChevronRight } from 'sushiweb/Icons';
import { useSelector } from 'react-redux';

const tabStyles = `
                  hr {
                    background-color: #318616 !important;
                    height: 4px;
                    border-radius: 4px 4px 0px 0px !important;
                  }
                  h2 {
                    border: none !important;
                  }
                `;

export const Tabs = ({
  activeIndex,
  links = [],
  align = 'left',
  gap = 0.5,
  width = 'inherit',
  setActiveAction = () => {},
  isLiveOrderViewEnabled = false,
  liveOrderTasks = [],
  showPing = true,
  orderId = null,
}) => {
  const handleClick = (index, link) => () => {
    setActiveAction(link, index);
  };

  const isNewUI = useSelector((state) => state?.ordersState?.isNewUI);

  if (!links?.length) return null;

  const liveOrderTaskCount = Array.isArray(liveOrderTasks)
    ? liveOrderTasks?.reduce((acc, task) => {
        if (!task) return acc;
        const taskStatus = task.status?.slug || '';
        if (
          taskStatus === TASK_STATUSES.inProgress ||
          taskStatus === TASK_STATUSES.OPEN
        ) {
          return acc + 1;
        }
        return acc;
      }, 0)
    : 0;

  const handleLeftScroll = () => {
    if (activeIndex === 0) return;
    setActiveAction(links[activeIndex - 1], activeIndex - 1);

    const tabId = `tab-${activeIndex - 1}-${orderId || ''}`;
    const tabElement = document.getElementById(tabId);

    if (tabElement) {
      tabElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  const handleRightScroll = () => {
    if (activeIndex === links.length - 1) return;
    setActiveAction(links[activeIndex + 1], activeIndex + 1);

    const tabId = `tab-${activeIndex + 1}-${orderId || ''}`;
    const tabElement = document.getElementById(tabId);

    if (tabElement) {
      tabElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  return (
    <Tabs.Wrapper width={width} className='tw-tabs-scroll'>
      {activeIndex !== 0 && isLiveOrderViewEnabled && (
        <div
          className=' tw-left-0 tw-h-full tw-w-10 tw-bg-gradient-to-r tw-from-[#e0e0e0] tw-to-transparent tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-hover:bg-opacity-80 tw-z-10'
          onClick={handleLeftScroll}
        >
          <ChevronLeft size={20} color='#434343' />
        </div>
      )}

      <HorizontalTabs alignLinks={align} additionalGap={gap}>
        {links?.map((tab, index) => {
          if (!tab) return null;
          if (tab.type === types.live_order_task && !isLiveOrderViewEnabled)
            return <></>;
          return (
            <React.Fragment key={tab.key}>
              <HorizontalTabs.Link
                id={`tab-${index}-${orderId || ''}`}
                style={{
                  flex: 1,
                  cursor: tab.cursor ?? 'pointer',
                  minWidth: '160px',
                  textAlign: 'center',
                  display: 'flex',
                  alignItems: 'center',
                  paddingLeft: '0.5rem',
                  justifyContent: 'center',
                  paddingTop: '0.5rem',
                }}
                active={activeIndex === index}
                onClick={handleClick(index, tab)}
                css={isNewUI ? tabStyles : ''}
              >
                <div
                  className={`tw-flex tw-gap-3 tw-items-center  tw-font-medium  ${
                    activeIndex === index && isNewUI
                      ? 'tw-text-base-green tw-text-[1.5rem]'
                      : ''
                  } `}
                >
                  {tab.title}
                  {tab.type === types.live_order_task &&
                    liveOrderTaskCount !== 0 &&
                    showPing && <AnimatePing text={liveOrderTaskCount} />}
                </div>
              </HorizontalTabs.Link>
            </React.Fragment>
          );
        })}
      </HorizontalTabs>
      {activeIndex !== links.length - 1 && isLiveOrderViewEnabled && (
        <div
          className='tw-right-0 tw-h-full tw-w-10 tw-bg-gradient-to-l tw-from-[#e0e0e0] tw-to-transparent tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-hover:bg-opacity-80 tw-z-10'
          onClick={handleRightScroll}
        >
          <ChevronRight size={20} color='#434343' />
        </div>
      )}
    </Tabs.Wrapper>
  );
};

Tabs.Wrapper = styled.div`
  width: ${(props) => props.width};
  section {
    display: flex;
  }
  h2 {
    margin-bottom: 0px;
  }
`;

function AnimatePing({ text = null, color = '#50b547' }) {
  return (
    <span
      css={`
        display: flex;
        height: 2.25rem;
        width: 2.25rem;
        align-self: center;
        position: relative;
      `}
    >
      <span
        css={`
          position: absolute;
          display: inline-flex;
          height: 100%;
          width: 100%;
          padding: 0.5rem;
          border-radius: 9999px;
          background: ${color};
          opacity: 0.75;
          animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
          @keyframes ping {
            75%,
            100% {
              transform: scale(1.75);
              opacity: 0;
            }
          }
        `}
      ></span>
      <span
        css={`
          position: relative;
          display: inline-flex;
          border-radius: 50%;
          border-radius: 9999px;
          background: ${color};
          height: 100%;
          width: 100%;
          color: white;
          align-items: center;
          justify-content: center;
        `}
      >
        {text}
      </span>
    </span>
  );
}
